import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { downloadArquivoDeBase64 } from 'src/app/helper';
import { IFatura } from 'src/app/interfaces';

@Component({
  selector: 'app-visualizar-pdf',
  templateUrl: './visualizar-pdf.component.html',
  styleUrls: ['./visualizar-pdf.component.scss']
})
export class VisualizarPdfComponent implements OnInit {
  @Input() dataBase64: string | null;
  @Input() nomeArquivo: IFatura;
  @Output() public closeModal: EventEmitter<any> = new EventEmitter<any>();
  pdf: any;

  constructor() {}

  ngOnInit() {
    this.pdf = this.convertToBinary(this.dataBase64);
  }

  downloadBoleto() {
    if (this.dataBase64 !== null) {
      downloadArquivoDeBase64({
        base64: this.dataBase64,
        nomeArquivo: `Boleto-${this.nomeArquivo.codFatura}-${this.nomeArquivo.codCliente}`,
        tipo: 'application/pdf'
      });
    }
  }

  convertToBinary(base64) {
    var raw = atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));

    for (let i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }

  public fecharModal() {
    this.closeModal.emit();
  }
}
